import { LeaderboardUser } from "./User/LeaderboardUser";

export type Leaderboard = {
  id: string;
  lastUpdated: number;
  count: number;
  users: LeaderboardUsers;
  missingSorts: number[];
};

export type LeaderboardUsers = {
  [uid: string]: LeaderboardUser | undefined;
};

export const getLeaderboardUsersBySort = (
  leaderboard: Leaderboard | undefined,
  minSort: number,
  maxSort: number
) => {
  if (!leaderboard) {
    return undefined;
  }

  return Object.values(leaderboard.users).filter((lbUser) => {
    if (!lbUser) {
      return false;
    }

    return lbUser.sort >= minSort && lbUser.sort <= maxSort;
  }) as LeaderboardUser[];
};

export const leaderboardUidCached = (leaderboard: Leaderboard, uid: string) => {
  return Object.keys(leaderboard.users).includes(uid);
};

export const leaderboardSortCached = (
  leaderboard: Leaderboard,
  sort: number
) => {
  return (
    leaderboard.missingSorts.includes(sort) ||
    Object.values(leaderboard.users).find((u) => u?.sort === sort)
  );
};
